<template>
  <!-- 单行表单 -->
  <div class="form-item">
    <div class="row-item" :class="[type === 'imei' ? 'imei' : '']">
      <div class="row-label" v-if="label">
        {{ label }} <span v-if="required" class="required">*</span>
      </div>
      <div class="row-content" :style="{ marginLeft: contentML }">
        <!-- 输入框 -->
        <div v-if="type === 'input'" class="w">
          <van-field
            v-model="itemValue"
            :placeholder="placeholder"
            @input="handleInput"
          />
        </div>
        <!-- 多行输入框 -->
        <div v-if="type === 'textarea'" class="w">
          <van-field
            v-model="itemValue"
            rows="1"
            autosize
            type="textarea"
            @input="handleInput"
            :placeholder="placeholder"
          />
        </div>
        <!-- 选择器 -->
        <div v-if="type === 'picker'" class="w" @click="handleClick">
          <span v-if="!itemValue">{{ placeholder }}</span>
          <div v-else>{{ itemValue }}</div>
          <i class="hjx-right"></i>
        </div>
        <!-- 照片行 -->
        <div v-if="type === 'photo'" class="w">
          <div class="photo-box">
            <div
              class="photo-item"
              v-for="(item, index) in itemValue"
              :key="index"
            >
              <img :src="item.src" alt="" class="photo-img" v-show="item.src" />
              <img
                src="@/assets/imgs/stockList/ic_pic_delete.png"
                alt=""
                class="hjx-photo-del"
                @click="delPhoto(index)"
                v-if="!onlyRead"
              />
              <div
                class="photo-shadow"
                :style="{ height: `${item.progress}%` }"
                v-show="!item.isFail && item.progress !== 100"
              ></div>
            </div>
            <div class="photo-item">
              <img
                src="@/assets/imgs/stockList/ic_picture.png"
                alt=""
                class="photo-img"
                @click="addPhoto"
                v-if="!onlyRead"
              />
              <input
                ref="upload"
                name="image"
                multiple
                accept="image/*"
                @click.stop
                @change="uploadFiles($event)"
                type="file"
                class="input-file"
              />
            </div>
          </div>
        </div>
        <!-- 文本 -->
        <div v-if="type === 'text'" class="w">
          {{ itemValue }}
        </div>
        <!-- imei -->
        <div v-if="type === 'imei'" class="w">
          <span v-if="!itemValue">{{ placeholder }}</span>
          <div v-else>{{ itemValue }}</div>
          <i class="hjx-imei-scan"></i>
        </div>
      </div>
    </div>
    <!-- imei -->
    <div class="row-item" v-if="type === 'imei'">
      <div class="row-label"></div>
      <div class="row-content imei">
        <van-checkbox v-model="notImei" @change="imeiChange">
          <span class="text" :class="{ bule: notImei }">无法获取IMEI</span>
          <template #icon="props">
            <img
              class="check-icon"
              :src="props.checked ? activeCheckIcon : norCheckIcon"
            /> </template
        ></van-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Checkbox } from 'vant';
import { cloudUpload } from '@/common/upload';
import { math } from '@/common/utils';
export default {
  name: 'app-form-item',
  data() {
    return {
      itemValue: '',
      notImei: false,
      activeCheckIcon: require('@/assets/imgs/stockList/ic_rate_select_act.png'),
      norCheckIcon: require('@/assets/imgs/stockList/ic_rate_select_nor .png'),
    };
  },
  props: {
    // 左侧标签
    label: {
      type: String,
      default() {
        return '';
      },
    },
    // 表单类型
    type: {
      type: String,
      default() {
        return 'input';
      },
    },
    value: {
      default() {
        return '';
      },
    },
    placeholder: {
      type: String,
      default() {
        return '';
      },
    },
    // 必填标记
    required: {
      type: Boolean,
      default() {
        return false;
      },
    },
    // 表单只读
    onlyRead: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    vanField: Field,
    vanCheckbox: Checkbox,
  },
  computed: {
    contentML() {
      if (this.type === 'photo') return '0';
      return '8px';
    },
  },
  created() {},
  mounted() {
    this.itemValue = this.value;
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    },
    handleClick() {
      this.$emit('picker');
    },
    imeiChange(val) {
      const value = val ? '无法获取' : '';
      this.$emit('input', value);
    },
    addPhoto() {
      this.$emit('addPhoto');
      this.$refs.upload.click();
    },
    delPhoto(index) {
      this.$appConfirm({
        title: '确认删除该照片吗?',
        confirmText: '确认',
        cancelText: '取消',
      }).then(
        () => {
          const arr = this.$_.cloneDeep(this.itemValue);
          arr.splice(index, 1);
          this.$emit('input', arr);
        },
        () => {}
      );
    },
    uploadFiles(e) {
      const vm = this;
      for (let index in e.currentTarget.files) {
        if (e.currentTarget.files.hasOwnProperty(index)) {
          const obj = {
            src: '',
            progress: 0,
            isFail: false,
          };
          vm.itemValue.push(obj);
          const item = e.currentTarget.files[Number(index)];
          cloudUpload({
            fileName: item.name,
            file: item,
            onProgress: res => {
              obj.progress = math.multiply(
                math.divide(res.loaded, res.total),
                100
              );
            },
          })
            .then(res => {
              obj.src = res.data.access_url;
            })
            .catch(() => {
              obj.isFail = true;
            });
        }
      }
    },
  },
  watch: {
    value(val) {
      this.itemValue = val;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/1px';
.app-form {
  width: 100%;
}
.form-item {
  &:not(:last-child) {
    position: relative;
    &:after {
      @include setBottomLine(#ececec);
    }
  }
}
.row-item {
  display: flex;
  padding: 12px 0;
  align-items: center;
  .row-label {
    font-family: PingFangSC-Regular;
    color: #777777;
    min-width: 67px;
    margin-right: 9px;
    line-height: 20px;
    .required {
      color: #e81f20;
      position: relative;
      left: -2px;
      top: -2px;
    }
  }
  .row-content {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .w {
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      word-wrap: break-word;
      word-break: break-all;
      line-height: 20px;
    }
    span {
      color: #cccccc;
    }
    .hjx-right {
      width: 16px;
      height: 16px;
      display: inline-block;
    }
    .hjx-imei-scan {
      width: 20px;
      height: 20px;
      display: inline-block;
    }
    ::v-deep {
      .van-cell {
        padding: 0;
        .van-field__control {
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(44, 44, 44, 1);
          line-height: 20px;
        }
        ::-webkit-input-placeholder {
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(204, 204, 204, 1);
          line-height: 20px;
        }
      }
    }
    &.imei {
      justify-content: flex-end;
      color: #2c2c2c;
      .text {
        color: #2c2c2c;
      }
      .bule {
        color: #2496ff;
      }
      .check-icon {
        width: 14px;
        height: 14px;
        display: block;
        position: relative;
        top: 3px;
      }
      ::v-deep {
        .van-checkbox__label {
          margin-left: 4px;
        }
      }
    }
  }
  &.imei {
    &:not(:last-child) {
      position: relative;
      &:after {
        @include setBottomLine(#ececec, 76px);
      }
    }
  }
  .photo-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    .photo-item {
      width: 102px;
      height: 102px;
      border-radius: 4px;
      margin-bottom: 12px;
      position: relative;
      .photo-img {
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
      }
      .hjx-photo-del {
        width: 20px;
        height: 20px;
        display: block;
        position: absolute;
        right: -6px;
        top: -6px;
        z-index: 9;
      }
      .photo-img + .photo-img {
        margin-left: 11px;
      }
    }
    .input-file {
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: -1;
    }
    .photo-shadow {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      bottom: 0;
      left: 0;
      border-radius: 0px 0px 4px 4px;
    }
    &::after {
      content: '';
      width: 102px;
      height: 0;
      display: block;
    }
  }
}
.add-tabs {
  padding: 16px 0 4px;
  display: flex;
  flex-wrap: wrap;
  .add-tab {
    height: 24px;
    line-height: 24px;
    padding: 0 6px;
    position: relative;
    &:before {
      @include setLine(#cccccc, 2px);
    }
    background-color: #fff;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #2c2c2c;
    &.active {
      background-color: rgba(255, 225, 0, 0.15);
      &:before {
        @include setLine(rgba(255, 225, 0, 1), 2px);
      }
      font-weight: 600;
    }
  }
  .add-tab + .add-tab {
    margin-left: 12px;
  }
}
.row-device {
  background: rgba(247, 247, 247, 1);
  border-radius: 6px;
  margin-top: 12px;
  .device-title {
    padding: 12px;
    position: relative;
    &:after {
      @include setBottomLine(#eeeeee);
    }
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .device-info {
    display: flex;
    padding: 12px 12px 12px 16px;
    .device-img {
      width: 52px;
      height: 60px;
      margin-right: 16px;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    .device-content {
      flex: 1;
      .device-name {
        font-size: 16px;
        font-family: PingFangSC-Medium;
        font-weight: bold;
        color: #202020;
        line-height: 22px;
        margin-bottom: 13px;
      }
      .device-money {
        font-size: 18px;
        font-weight: 600;
        font-family: PingFangSC-Semibold, PingFang SC;
        max-width: 120px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .rmb {
          font-size: 12px;
          font-weight: bold;
        }
      }
      .device-operator {
        margin-left: auto;
        font-size: 13px;
        font-family: PingFangSC-Regular;
        color: #777777;
        line-height: 18px;
        padding-top: 4px;
        max-width: 100px;
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>

